import { csrfTokenService } from '../csrf/CsrfTokenService'

export class ResendLastBookingConfirmationEmailFetch {
  async requestResendBookingConfirmationEmail(email: string): Promise<void> {
    const { csrfToken } = await csrfTokenService()
    try {
      return $fetch<void>('/_/fallback/about/resend_confirmation_email/', {
        method: 'POST',
        body: this.getFormData(email),
        headers: {
          'X-ELDARION-AJAX': 'true',
          'X-CSRFToken': csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
    } catch (error) {
      throw new Error(error.response?.data?.errors)
    }
  }

  private getFormData(email): FormData {
    const form = new FormData()
    form.append('email', email)
    return form
  }
}
